import React from 'react';
import '../../css/pages/TermsAndConditions.css';

const TermsAndConditions = () => {
  return (
    <div className="terms-container">
      <h1 className="terms-title">SmartGPT Tag Assistant Terms and Conditions</h1>
      <div className="terms-content">
        <p><strong>Last Updated: June 23, 2025</strong></p>
        
        <h2>1. Acceptance of Terms</h2>
        <p>By installing, accessing, or using the SmartGPT Tag Assistant Chrome Extension (“Extension”, “we”, “our”), you (“User”, “you”) agree to be bound by these Terms and Conditions.</p>
        <p>Your use of the Extension is also subject to our Privacy Policy. Please review it carefully.</p>
        <p>If you do not agree, do not use the Extension.</p>
        
        <h2>2. Description of Service</h2>
        <p>SmartGPT Tag Assistant provides AI-powered smart tag replacements inside input fields. The extension includes free and premium features, subscription plans, and usage limits.</p>
        <p>We may update or modify features at any time without prior notice.</p>
        
        <h2>3. User Accounts</h2>
        <p>To access full functionality, you must log in using your Google account. You agree to:</p>
        <ul>
          <li>Provide accurate account information.</li>
          <li>Maintain the security of your credentials.</li>
          <li>Not impersonate others or misuse another user’s identity.</li>
        </ul>
        <p>We reserve the right to suspend or terminate accounts for violation of these terms.</p>
        
        <h2>4. Subscription Plans</h2>
        <p>We offer multiple plans:</p>
        <ul>
          <li><strong>FREE:</strong> Basic features with limited prompts.</li>
          <li><strong>PRO / PRO+:</strong> Paid subscriptions with enhanced features.</li>
        </ul>
        <p>Details of each plan (quota, pricing, duration) are available on our official website.</p>
        <p>We reserve the right to modify or discontinue plans or pricing at any time.</p>
        
        <h2>5. Usage Restrictions</h2>
        <p>You agree NOT to:</p>
        <ul>
          <li>Reverse-engineer, tamper with, or redistribute the Extension.</li>
          <li>Use the Extension to generate harmful, illegal, or unethical content.</li>
          <li>Attempt unauthorized access to our backend systems or user data.</li>
        </ul>
        <p>Violation of these rules may result in suspension or termination of your account.</p>
        
        <h2>6. Intellectual Property</h2>
        <p>All content, design, and code related to SmartGPT Tag Assistant is owned by the developer.
        You may not reuse, copy, or resell any part of the Extension or website without permission.</p>
        
        <h2>7. Privacy</h2>
        <p>We are committed to protecting your privacy. Please review our Privacy Policy to understand how we collect, store, and use your data.</p>
        
        <h2>8. Disclaimer of Warranties</h2>
        <p>We provide this Extension “as is” and without warranties of any kind.
        We do not guarantee that the service will be error-free, uninterrupted, or suitable for your specific needs.</p>
        
        <h2>9. Limitation of Liability</h2>
        <p>We are not liable for any indirect, incidental, or consequential damages arising from your use of the Extension, including but not limited to:</p>
        <ul>
          <li>Loss of data</li>
          <li>Service interruptions</li>
          <li>AI-generated inaccuracies</li>
        </ul>
        <p>Your sole remedy is to stop using the Extension.</p>
        
        <h2>10. AI Disclaimer & Limitation of Responsibility</h2>
        <p>SmartGPT Tag Assistant uses third-party AI services to generate content based on user input. While we aim to provide helpful and efficient responses, we do not guarantee the accuracy, reliability, legality, or appropriateness of the AI-generated output.</p>
        <p>By using this Extension, you acknowledge and agree that:</p>
        <ul>
          <li>You are solely responsible for any content submitted to or generated by the AI system through this Extension.</li>
          <li>You will not use the AI output for unlawful, unethical, harmful, or deceptive purposes, including but not limited to:
            <ul>
              <li>Academic cheating or plagiarism</li>
              <li>Fraudulent communication or identity misuse</li>
              <li>Harassment, discrimination, or defamation</li>
              <li>Legal or medical advice without proper validation</li>
              <li>Automation of spam or abusive behavior</li>
            </ul>
          </li>
        </ul>
        <p>We do not monitor, verify, or endorse any content generated via the Extension.</p>
        <p>We are not liable for any consequences (legal, academic, financial, reputational, or otherwise) arising from your use or misuse of AI-generated content.</p>
        
        <h2>11. Termination</h2>
        <p>We may suspend or terminate your access to the Extension at any time, with or without notice, if we believe you violated these Terms.</p>
        <p>You may also uninstall the Extension at any time.</p>
        
        <h2>12. Governing Law</h2>
        <p>These Terms shall be governed by and construed in accordance with the laws of India, without regard to its conflict of laws.</p>
        
        <h2>13. Changes to These Terms</h2>
        <p>We may update these Terms from time to time. When changes are made:</p>
        <ul>
          <li>Continued use of the Extension constitutes acceptance of the new Terms.</li>
        </ul>

        <h2>14. Refunds and Cancellations</h2>
        <p>Please note that we do not offer refunds or cancellations for any subscriptions, payments, or services purchased through our Chrome extension Or website. All payments made are final and non-refundable, including in cases of:</p>
        <ul>
          <li>Accidental purchases</li>
          <li>Unused subscriptions</li>
          <li>User dissatisfaction</li>
          <li>Feature limitations</li>
        </ul>
        <p>We encourage you to try the free version (if available) before making a payment. If you experience technical issues, please contact us at pixelinnovators.21@gmail.21@gmail.com, and we will do our best to resolve the problem.</p>
        
        <h2>15. Contact Us</h2>
        <p>If you have any questions about these Terms, please contact:</p>
        <p>📧 pixelinnovators.21@gmail.com</p>
      </div>
    </div>
  );
};

export default TermsAndConditions;